<template>
	<div>
		<div class="header">
			<div class="header-title">
				<div class="header-title-img">
					<!--<img src="./../../assets/LOGO.png" />-->
					<img src="./../../assets/lg.png" />
				</div>
				<!--
				<div class="header-title-select" v-closeOut="closeOut">
					<div class="header-title-input-box">
						<span>当前:</span>
						<span>{{ areaname }}</span>
					</div>
				
					<div
						class="header-title-select-box"
						@click="showSelect = !showSelect"
					>
						<span>切换区域</span>
						<span :class="{ 'heaser-select-arrow': showSelect }">
							<i class="iconfont icon-icon-test"></i>
						</span>
					</div>
					<div class="header-title-select-list" v-show="showSelect">
						<div class="header-title-select-list-box">
							<div class="header-title-select-list-type">
								<span>市级</span>
							</div>
							<div class="header-title-select-list-code">
								<ul>
									<li
										v-for="(city, cityIndex) in areaList"
										:key="cityIndex"
										v-show="city.ParentId == 0"
										:class="{ active: areacode == city.Code }"
										@click="setArea(city.Code, city.Name)"
									>
										<span>{{ city.Name }}</span>
									</li>
								</ul>
							</div>
						</div>
						<div class="header-title-select-list-box">
							<div class="header-title-select-list-type">
								<span>区级</span>
							</div>
							<div class="header-title-select-list-code">
								<ul>
									<li
										v-for="(city, cityIndex) in areaList"
										:key="cityIndex"
										v-show="city.ParentId == 1"
										:class="{ active: areacode == city.Code }"
										@click="setArea(city.Code, city.Name)"
									>
										<span>{{ city.Name }}</span>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
					-->
			</div>
			<div class="header-menu">
				<ul class="menu-ul">
					<li class="menu-li">
						<a
							class="menu-a"
							href="javascript:void(0)"
							@click="toPage('/', 1)"
							:class="{ active: current == 1 }"
							>首页</a
						>
					</li>
					<li class="menu-li">
						<a
							class="menu-a"
							href="javascript:void(0)"
							@click="toPage('/policy', 2)"
							:class="{ active: current == 2 }"
							>政策文件</a
						>
					</li>
					<!-- <li class="menu-li">
            <a
              class="menu-a"
              href="javascript:void(0)"
              @click="toPage('/inventory', 3)"
              :class="{ active: current == 3 }"
            >清单调整统计</a>
          </li>
          -->
				</ul>
			</div>
			<!-- <div class="header-time">{{ time }}</div> -->
		</div>
		<div class="content">
			<router-view :areacode="areacode" :areaname="areaname" />
		</div>
		<div class="goTop" v-if="goTopShow" @click="goTop">
			<img src="./../../assets/top.png" />
		</div>
		<div class="floor_box" style="display:none">
			<p>
				<span>主办方：新乡市委机构编制委员会办公室</span>
				<!--<span>版权所有：新乡市委机构编制委员会办公室</span>-->
			</p>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				time: "",
				goTopShow: false,
				current: 1,
				showSelect: false,
				areaList: [],
				areacode: 0,
				areaname: "",
			};
		},
		directives: {
			closeOut: {
				bind(el, binding, vnode) {
					function documentHandler(e) {
						if (el.contains(e.target)) {
							return false;
						}
						if (binding.expression) {
							binding.value(e);
						}
					}

					function KeyUp(e) {
						if (e.keyCode == 27) {
							if (binding.expression) {
								binding.value(e);
							}
						}
					}
					el.__vueClickOutSize__ = documentHandler;
					el.__vueKeyup__ = KeyUp;

					document.addEventListener("keyup", KeyUp);
					document.addEventListener("click", documentHandler);
				},
				unbind(el, binding) {
					document.removeEventListener("click", el.__vueClickOutSize__);
					delete el.__vueClickOutSize__;

					document.removeEventListener("keyup", el.__vueKeyup__);
					delete el.__vueKeyup__;
				},
			},
		},
		methods: {
			closeOut() {
				this.showSelect = false;
			},
			setArea(Code, name) {
				this.areacode = Code;
				this.areaname = name;
				this.showSelect = false;
			},
			initArea() {
				this.$axios({
					url: "api/GetAreaList",
					method: "get",
				})
					.then((res) => {
						this.areaList = res.data.areaList;
						let area = res.data.areaList.find((arr) => arr.ParentId == 0);
						this.areaname = area.Name;
						this.areacode = area.Code;
					})
					.catch((err) => {
						console.info(err);
					});
			},
			// initTime() {
			//   setInterval(() => {
			//     let date = new Date();
			//     let year = date.getFullYear();
			//     let month = date.getMonth() + 1;
			//     let day = date.getDate();
			//     let hours = date.getHours();
			//     let minutes = date.getMinutes();
			//     let seconds = date.getSeconds();
			//     this.time =
			//       year +
			//       "年" +
			//       (month < 10 ? "0" + month : month) +
			//       "月" +
			//       (day < 10 ? "0" + day : day) +
			//       "日  " +
			//       (hours < 10 ? "0" + hours : hours) +
			//       ":" +
			//       (minutes < 10 ? "0" + minutes : minutes) +
			//       ":" +
			//       (seconds < 10 ? "0" + seconds : seconds);
			//   }, 1000);
			// },
			scrollTop() {
				let scrollTop =
					document.documentElement.scrollTop || document.body.scrollTop;
				if (scrollTop > 50) {
					this.goTopShow = true;
				} else {
					this.goTopShow = false;
				}
			},
			goTop() {
				document.getElementById("app").scrollIntoView({ behavior: "smooth" });
			},
			toPage(path, current) {
				this.current = current;
				localStorage.setItem("current", current);
				this.$router.push({ path: path });
			},
		},
		mounted() {
			// this.initTime();
			this.initArea();
			window.addEventListener("scroll", this.scrollTop);
			if (localStorage.getItem("current")) {
				this.current = localStorage.getItem("current");
			}
		},
	};
</script>

<style lang="scss" scoped>
	.header {
		width: 100%;
		height: 166px;
		// background-image: url("./../../assets/xinxiang.png");
		// background-position: center 0;
		// background-repeat: no-repeat;
		// background-size: 100% 100%;
		background-color: #ffffff;
		position: relative;
		.header-title {
			// position: absolute;
			// top: 80px;
			left: 0;
			right: 0;
			margin: auto;
			position: relative;
			width: 1200px;
			min-width: 1200px;
			height: 100px;
			// background-image: url("./../../assets/d5.png");
			// background-position: left center;
			// background-repeat: no-repeat;
			.header-title-img {
				float: left;
				width: 920px;
				height: 100px;
				padding: 15px 30px;
				img {
					width: 750px;
					height: 70px;
					float: left;
				}
			}
			.header-title-select {
				width: 280px;
				height: 100px;
				float: right;
				padding: 25px 0;
				.header-title-input-box {
					width: 160px;
					height: 50px;
					float: left;
					background: #eeeeee;
					border-top-left-radius: 2px;
					border-bottom-left-radius: 2px;
					display: flex;
					justify-content: space-evenly;
					align-items: center;
					span {
						display: inline-block;
						font-size: 16px;
						font-family: Microsoft YaHei;
						font-weight: 400;
						&:first-of-type {
							color: #d3d3d3;
						}
						&:last-of-type {
							color: #666666;
						}
					}
				}
				.header-title-select-box {
					width: 120px;
					height: 50px;
					float: right;
					background: #2674ec;
					border-top-right-radius: 2px;
					border-bottom-right-radius: 2px;
					text-align: center;
					line-height: 50px;
					cursor: pointer;
					span {
						font-family: 微软雅黑;
						font-weight: 400;
						color: #ffffff;
						font-size: 16px;
						i {
							display: inline-block;
							transform: rotate(180deg);
							transition: all 0.5s;
						}
					}
					.heaser-select-arrow {
						i {
							transform: rotate(0deg);
						}
					}
				}
				.header-title-select-list {
					width: 968px;
					height: auto;
					position: absolute;
					right: 0;
					top: 100%;
					margin: auto;
					z-index: 999;
					background-color: #ffffff;
					box-shadow: -3px 3px 5px 1px rgba(226, 37, 25, 0.09);
					padding: 20px 50px;
					.header-title-select-list-box {
						width: 100%;
						height: auto;
						display: flex;
						.header-title-select-list-type {
							width: 100px;
							height: 40px;
							min-width: 100px;
							span {
								font-size: 16px;
								font-family: Microsoft YaHei;
								font-weight: 400;
								color: #666666;
								line-height: 40px;
								text-align: center;
							}
						}
						.header-title-select-list-code {
							width: 100%;
							height: auto;
							ul {
								width: 100%;
								li {
									width: 90px;
									height: 40px;
									float: left;
									list-style-type: none;
									cursor: pointer;
									span {
										font-size: 16px;
										font-family: Microsoft YaHei;
										font-weight: 400;
										color: #666666;
										line-height: 40px;
										text-align: center;
									}
									&.active {
										background: #cd0600;
										border-radius: 2px;
										span {
											color: #ffffff;
										}
									}
								}
							}
						}
					}
				}
			}
		}
		.header-menu {
			position: relative;
			left: 0;
			right: 0;
			margin: auto;
			width: 1200px;
			min-width: 1200px;
			height: 66px;
			padding: 3px 30px;
			.menu-ul {
				width: auto;
				height: 60px;
				.menu-li {
					float: left;
					width: auto;
					height: 60px;
					list-style-type: none;
					margin-right: 30px;
					.menu-a {
						font-size: 20px;
						letter-spacing: 2px;
						padding: 10px 15px;
						line-height: 60px;
						text-decoration: none;
						color: #333333;
						font-family: Microsoft YaHei;
						font-weight: bold;
						border-bottom: 4px solid transparent;
						transition: all 0.3s;
						&.active {
							border-bottom: 4px solid #cd0600;
						}
					}
				}
			}
		}

		.header-time {
			width: auto;
			position: absolute;
			right: 50px;
			top: 0;
			height: 60px;
			line-height: 60px;
			color: #f1f1f1;
		}
	}
	.content {
		width: 100%;
		min-width: 1200px;
		// margin-top: -150px;
		height: auto;
		// border: 1px solid black;
		left: 0;
		right: 0;
		margin-left: auto;
		margin-right: auto;
	}
	.goTop {
		position: fixed;
		right: 50px;
		bottom: 50px;
		width: 50px;
		height: 50px;
		animation: imgJump 0.5s linear 0s infinite alternate;
		cursor: pointer;
		img {
			width: 100%;
			height: 100%;
		}
	}
	.floor_box {
		width: 100%;
		height: 30px;
		line-height: 30px;
		position: relative;
		bottom: 0;
		left: 0;
		right: 0;
		margin: 30px auto auto auto;
		background-color: #bdc3c7;
		p {
			width: 100%;
			height: 30px;
			line-height: 30px;
			text-align: center;
			span {
				font-size: 14px;
				font-family: 微软雅黑;
				letter-spacing: 1px;
				color: #333333;
				&:first-of-type {
					margin-right: 50px;
				}
			}
		}
	}
	@keyframes imgJump {
		from {
			bottom: 50px;
		}
		to {
			bottom: 60px;
		}
	}
</style>
